import { ReconciliationListContainer } from './list/container';
import { ReconciliationViewContainer } from './view/container';

export const ReconciliationsListRoute = ReconciliationListContainer;

export const ReconciliationsViewRoute = ReconciliationViewContainer;
